import { NotificationDataPointType, NotificationType } from '../../pillar2-proxies';

export class ProjectNotificationSetings {
    static getTypeIcon(status: NotificationType | string): string {
        switch (status) {
            case NotificationType.Error: {
                return 'pi pi-ban mz-red';
            }
            case NotificationType.Warning: {
                return 'pi pi-exclamation-triangle mz-orange';
            }
            case NotificationType.Info: {
                return 'pi pi-info-circle';
            }
            default: {
                return 'pi pi-info-circle';
            }
        }
    }

    static getTypeName(status: NotificationType | string): string {
        switch (status) {
            case NotificationType.Error: {
                return 'NotificationType_Error';
            }
            case NotificationType.Warning: {
                return 'NotificationType_Warning';
            }
            case NotificationType.Info: {
                return 'NotificationType_Info';
            }
            default: {
                return 'NotificationType_Info';
            }
        }
    }

    static getDataPointPrefix(type: NotificationDataPointType) {
        switch (type) {
            case NotificationDataPointType.OrganizationalEntity: {
                return 'DataPointType_Entity';
            }
            case NotificationDataPointType.BlendingCircleSubgroup: {
                return 'DataPointType_BlendingCircleSubgroup';
            }
            case NotificationDataPointType.ConversionRate: {
                return 'DataPointType_CurrencyConversionRate';
            }
            case NotificationDataPointType.SafeHarbourGroup: {
                return 'DataPointType_SafeHarbourGroup';
            }
            case NotificationDataPointType.OwnershipChange: {
                return 'DataPointType_OwnershipChange';
            }
            case NotificationDataPointType.BlendingCircle: {
                return 'DataPointType_BlendingCircle';
            }
            default: {
                return '';
            }
        }
    }
}
